import jhsfBookingsApi from '../apis/jhsfBookingsApi';
import { IWeekdayActivitySchedule } from './ListWeekdaysActivitySchedulesService';

interface IListExternalLinkActivityScheduleProps {
  activityId: string;
  activityScheduleId?: string;
  addDay?: number;
  selectedMonth?: number;
  startDate?: string;
  userId?: string;
}

export const listExternalLinkActivitiesSchedulesService = async ({
  activityId,
  activityScheduleId,
  addDay,
  selectedMonth,
  startDate,
  userId,
}: IListExternalLinkActivityScheduleProps): Promise<
  IWeekdayActivitySchedule[]
> => {
  const { data } = await jhsfBookingsApi.get(
    `/activities/${activityId}/schedules/external-link`,
    {
      params: {
        activityScheduleId,
        addDay,
        selectedMonth,
        startDate: startDate || undefined,
        userId,
      },
    },
  );

  return data;
};
